const config = {
  // 测试环境
  test: {
    env: 'test',
    baseURL: '//testpaycenter.zhiyoubao.com',
    pathRewrite: {
      // '^/paycenter-charge': '',
      // '^/api/user': '//testpaycenter.zhiyoubao.com/api/user',
    },
    userDomian: 'http://testuser.lotsmall.cn',// 用户中心地址
    openDomain: 'http://testopen.zhiyoubao.com',// 开放平台地址
    // lotsmallDomain: 'https://testwww.lotsmall.cn',// 智游宝商城B端地址
    lotsmallDomain: 'https://testtrade.lotsmall.cn',// 智游宝商城B端地址 新交易

  },
  // 预发环境
  pre: {
    env: 'pre',
    baseURL: '//prepaycenter.zhiyoubao.com',
    pathRewrite: {
      // '^/paycenter-charge': '',
      // '^/api/user': '//prepaycenter.zhiyoubao.com/api/user',
    },
    userDomian: 'http://preuser.lotsmall.cn',
    openDomain: 'https://open.zhiyoubao.com',
    lotsmallDomain: 'https://prewww.lotsmall.cn',// 智游宝商城B端地址
  },
  // 生产环境
  prod: {
    env: 'prod',
    baseURL: '//paycenter.zhiyoubao.com',
    pathRewrite: {
      // '^/paycenter-charge': '',
      // '^/api/user': '//paycenter.zhiyoubao.com/api/user',
    },
    userDomian: 'http://user.lotsmall.cn',
    openDomain: 'https://open.zhiyoubao.com',
    lotsmallDomain: 'https://www.lotsmall.cn',// 智游宝商城B端地址
  },
  // stable 环境
  stable: {
    env: 'stable',
    baseURL: '//stablepaycenter.zhiyoubao.com',
    pathRewrite: {
      // '^/paycenter-charge': '',
      // '^/api/user': '//stablepaycenter.zhiyoubao.com/api/user',
    },
    userDomian: 'http://testuser.lotsmall.cn',
    openDomain: 'https://open.zhiyoubao.com',
  },
  // 游湖北正式环境
  youhubei: {
    env: 'youhubei',
    baseURL: '//paycenter.youhubei.cn',
    pathRewrite: {
      // '^/paycenter-charge': '',
      // '^/api/user': '//stablepaycenter.zhiyoubao.com/api/user',
    },
    userDomian: 'https://usermg.youhubei.cn',
    openDomain: 'https://open.youhubei.cn',
    lotsmallDomain: 'https://lotsmg.youhubei.cn',// 智游宝商城B端地址
  },
  // // 游湖北测试环境
  // youhubeiTest: {
  //   env: 'youhubeiTest',
  //   baseURL: '//testpaycenter.youhubei.cn',
  //   pathRewrite: {
  //     // '^/paycenter-charge': '',
  //     // '^/api/user': '//stablepaycenter.zhiyoubao.com/api/user',
  //   },
  //   userDomian: 'https://testusermg.youhubei.cn',
  //   openDomain: 'https://testopen.youhubei.cn',
  //   lotsmallDomain: 'https://testlotsmg.youhubei.cn',// 智游宝商城B端地址
  // },
  // 开发环境
  dev: {
    env: 'dev',
    // baseURL: '//192.168.200.88:10030',
    baseURL: '//testpaycenter.zhiyoubao.com',
    pathRewrite: {
      // '^/paycenter-charge': 'http://192.168.77.204:10030', // 叶维
      // '^/api/user': '//testpaycenter.zhiyoubao.com/api/user',
      // '^/paycenter-charge/api/worktable': '//192.168.200.88:10030/api/worktable',

    },
    userDomian: 'http://testuser.lotsmall.cn',
    openDomain: 'http://testopen.zhiyoubao.com',// 开放平台地址
    lotsmallDomain: 'https://testwww.lotsmall.cn',// 智游宝商城B端地址
  },
};
let env = '';
if (location.hostname === 'testbusiness.zhiyoubao.com') {
  // 测试环境
  env = 'test';
} else if (location.hostname === 'stablebusiness.zhiyoubao.com') {
  // 测试环境1
  env = 'stable';
} else if (location.hostname === 'prebusiness.zhiyoubao.com') {
  // 预发环境
  env = 'pre';
} else if (['www.zybcloud.com','business.zhiyoubao.com'].includes(location.hostname)) {
  // 正式环境
  env = 'prod';
} else if (location.hostname === 'market.youhubei.cn') {
  // 游湖北正式环境
  env = 'youhubei';
}
// else if (location.hostname === 'testmarket.youhubei.cn') {
//   // 游湖北正式环境
//   env = 'youhubeiTest';
// }
else {
  // 开发环境
  env = 'dev';
}
export default config[env];
